<template>
	
  <div class="home">
<div class="works-ban">
	
		<p> 
 MEMBER CENTER              </p>
	</div>
   <div class="mem-full">

 <Center title='3' />

<div class="mem-con">
	<div class="address">
		<div class="men-l1">
			<div class="re-tit">
					   <h4>Saved shipping address</h4>
			</div>
			<div class="re-con">
				<ul>
					<li v-for="item in news">
						<div class="l1">
							<span>{{item.name}}</span><span v-if="item.if_default==1">Default address</span>
						</div>
						<div class="l2">
							{{item.areaName}}
							{{item.address}}
							
						</div>
						<div class="l3">
							<span>	{{item.phone}}</span>
						</div>
					</li>
				
		
					<div class="clear"></div>
				</ul>
			</div>
		</div>
		
	</div>

	<div class="login-r1">
	<div class="re-tit add-ship">
		<h4>Add shipping address</h4>
		
		
	</div>
	<div class="add-for">
	
	<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px"  label-position="top"  size="mini">
		<el-row :gutter="20">
			 <el-col :span="12">
	  <el-form-item label="First name" prop="first_name">
	    <el-input v-model="ruleForm.first_name"></el-input>
	  </el-form-item>
	  </el-col>
	  <el-col :span="12">
	  <el-form-item label="Last name" prop="last_name">
	    <el-input v-model="ruleForm.last_name"></el-input>
	  </el-form-item>
	  </el-col>
	 </el-row>
	 

	 
	 <el-row :gutter="20">
	 			 <el-col :span="12">
	  <el-form-item label="Phone" prop="phone">
	    <el-input v-model="ruleForm.phone"></el-input>
	  </el-form-item>
	  </el-col>
	  <el-col :span="12">
	  <el-form-item label="Nickname" prop="nickname" >
	    <el-input v-model="ruleForm.nickname"></el-input>
	  </el-form-item>
	  </el-col>
	 </el-row>
	 
	 
	 <el-row :gutter="20">
	 			 <el-col :span="12">
	<el-form-item label="Country / Region"  prop="country">
	   <el-select v-model="ruleForm.country" placeholder="Please fill in Country">
	     <el-option v-for="item in sun" :label="item.NAME" :value="item.NAME"></el-option>
		  
	   </el-select>
	 </el-form-item>
	  </el-col>
	  <el-col :span="12">
	  <el-form-item label="ID" prop="identity_id">
	    <el-input v-model="ruleForm.identity_id" placeholder="China and Taiwan must fill in the ID card number"></el-input>
	  </el-form-item>
	  </el-col>
	 </el-row>
	 <el-row :gutter="20">
	 			 <el-col :span="24" >
	  <el-form-item label="Address Line" prop="address_line">
	    <el-input v-model="ruleForm.address_line"></el-input>
	  </el-form-item>
	  </el-col>
	
	 </el-row>

	 <el-row :gutter="20">
	 			 <el-col :span="8">
	  <el-form-item label="Province" prop="province">
	    <el-input v-model="ruleForm.province"></el-input>
	  </el-form-item>
	  </el-col>
	  <el-col :span="8">
	  <el-form-item label="Town / City" prop="city">
	    <el-input v-model="ruleForm.city"></el-input>
	  </el-form-item>
	  </el-col>
	  <el-col :span="8">
	  <el-form-item label="Postcode / ZIP" prop="postcode">
	    <el-input v-model="ruleForm.postcode"></el-input>
	  </el-form-item>
	  </el-col>
	 </el-row>
	 <el-row>
	  <el-form-item > 
	  <el-switch active-color="#050505" @change="full" v-model="moren"></el-switch><span class="add-set">Set as default address</span>
	  </el-form-item>
	  </el-row>
	 <el-row :gutter="20">

	 </el-row>
	 
	<div class="h-button" @click="submitForm('ruleForm')">REGISTER</div>
	 
	 
	  </el-form-item>
	</el-form>
	
	</div>
	</div>

	
</div>
   </div>

    </div>
</template>
<script>

import Center from '@/components/center/center'

export default {
  components: {
   Center
  },
  data() {
    return {
		page:1,
		pagenum:100,
		moren:false,
		sun:'',
		news:'',
           ruleForm: {
           	first_name:'',
           	last_name:'',
         
           	phone:'',
           	nickname:'',
           	country:'',
           	identity_id:'',
           	address_line:'',
           	province:'',
           	city:'',
           	postcode:'',
			moren: 0,
          
               
                 },
                 rules: {
                 	
                 	   first_name: [
                 	    { required: true, message: 'Please fill in First name', trigger: 'blur' },
                 ],last_name: [
                 	    { required: true, message: 'Please fill in Last name', trigger: 'blur' },
                 ],phone: [
                 	    { required: true, message: 'Please fill in Phone', trigger: 'blur' },
                 ],country: [
                 	    { required: true, message: 'Please fill in Country', trigger: 'change' },
                 ],address_line: [
                 	    { required: true, message: 'Please fill in Address Line 1', trigger: 'blur' },
                 ],province: [
                 	    { required: true, message: 'Please fill in Province', trigger: 'blur' },
                 ],city: [
                 	    { required: true, message: 'Please fill in City', trigger: 'blur' },
                 ],postcode: [
                 	    { required: true, message: 'Please fill in Postcode', trigger: 'blur' },
                 ],nickname: [
                 	    { required: true, message: 'Please fill in nickname', trigger: 'blur' },
                 ],identity_id: [
                 	    { required: true, message: 'Please fill in ID', trigger: 'blur' },
                 ]
                  
                   }
          };
  },  mounted() {
	  
	  this.id = this.$route.query.id

		this.sandMate();
		this.sandCase();
		},methods: {
			
		 submitForm(formName) {
		
			      
		        this.$refs[formName].validate((valid) => {
		          if (valid) {
		         this.$axios({
		           method: "post",
		           url: "service.php?action=userAddress_add",
		           data: this.ruleForm,  
		         }).then((res) => {
		         	let data=res.data;
		         			
		         	if(data.code==1){
						
					this.$message.success(data.message);
					this.sandMate()
		  
		         	}else{  
						this.$message.error(data.message);
						      
					}
		          
		         });
				 
				 
		          } else {
		           
		            return false;
		          }
		        });
		      },
			  full(){
				  if(this.moren){
					  this.ruleForm.moren= 1
				  }else{
					   this.ruleForm.moren= 0
				  }
			
			  },
			 sandCase(){
			  	this.$axios({
			  	  method: "post",
			  	  url: "service.php?action=userAddress_country",
			  	  data: {},  
			  	}).then((res) => {
			  		let data=res.data;
			  	
			  		if(data.code==1){
			  			this.sun=data.data;
			  		}
			  	 
			  	});
			  
			  },
			  sandMate(){
			  	this.$axios({
			  	  method: "post",
			  	  url: "service.php?action=userAddress_lists",
			  	  data: {page:this.page,pagenum:this.pagenum},  
			  	}).then((res) => {
			  		let data=res.data;
			  
			  		if(data.code==1){
			  	
			  							
			  			this.news=data.data;
			  			
			  			
			  		}
			  	 
			  	});
			  
			  },
		      resetForm(formName) {
		        this.$refs[formName].resetFields();
		      }
		}
};
</script>
<style lang="scss" scoped>
	
	.h-button{
			text-align: center;
			cursor: pointer;
			width: 185px;
			padding: 0 50px;
			height: 50px;
			line-height: 50px;
			background: #000;
			color: #FFFFFF;
			margin-top: 30px;
		
		}
		.h-button:hover{
			background-color: #333333;
		}
	.login{
		padding: 20px 0;
		.re-tit{
			line-height: 50px;
			h4{
				font-size: 26px;
				
			}
			margin-bottom: 20px;
		}
	}	
.login-r1{

}
.login-r2{
	width:490px;

	padding: 50px;
	float: left;

}
.address{
	.re-con{
		li{
			width: 374px;
			height: 190px;
			background: #F8F8F8;
			border: 1px solid #D2D2D2;
			float: left;
			margin-right: 23px;
			margin-bottom: 20px;
			.l1{
				display: flex;
				height: 50px;
				justify-content: space-between;
				align-items: center;
				border-bottom: 1px dotted #DDDDDD;
				padding: 0 20px;
			}
.l2{
			
				height: 50px;
				
				border-bottom: 1px dotted #DDDDDD;
				padding:15px 20px;
			}
			.l3{
				display: flex;
				height: 50px;
				justify-content: space-between;
				align-items: center;
		
				padding: 0 20px;
			}
		}
		.plus{
			display: flex;
			flex-direction:column ;
			justify-content: center;
			align-items: center;
			img{
				width: 33px;
				height: 33px;
			}
		}
	}
}

	.works-ban{
		font-family: 'Arial-BoldMT';
		padding-top: 15px;
		background: #0A0A0A;
		height: 57px;
		color: #FFFFFF;
		text-align: center;
		line-height: 40px;
		h2{
			font-size: 43px;
		}
		span{
			margin: 20px;
			color: #B5B5B5;
		}
		.acts{
			color: #FFFFFF;
			font-weight: bolder;
		}
	}

.mem-full{
	display: flex;
	width: 1200px;
	margin: 20px auto;
}

.mem-con{
	flex: 1;
	margin-left: 20px;
	.men-l1{
		border: 1px solid #D2D2D2;
		.re-tit{
			line-height: 50px;
			border-bottom: 1px solid #D2D2D2;
			h4{
				margin-left: 20px;
			}
			
		}
		.re-con{
			padding: 20px;
		}
	}
}
.add-for{
padding: 30px;
	background: #F8F8F8;
	border: 1px solid #D2D2D2;
	

}
.add-ship{
	margin: 20px 0;
}
.add-set{
	margin-left: 10px;
}
</style>